<template src="./template.html"> </template>

<script>
export default {
  name: "CIframe",
  components: {},
  data() {
    return {
      iframe: {
        src: "",
      },

      iframeLoading: true,

    };
  },
  methods: {

    onLoad() {
      
      let currentRoute = this.$route.path;
      let routes = this.$store.state.routes;
      let url;

      for (let item of routes) {
        if (currentRoute == ('/' + item.function_tab) && item.function_is_frame) {
          url = item.function_soft;
          break;
        } else {
          for (let subItem of item.children) {
              if (currentRoute == ('/' + subItem.function_tab) && subItem.function_is_frame) {
                url = subItem.function_soft;
                break;
              }
          }
        }
      }

      if (url) {
        this.iframe.src = url;
        this.iframeLoading = false;
      } else {
        this.iframeLoading = true;  
      }
      
      console.log("onLoad: iframe loaded");
      
    },
    
    onIframeLoad() {
      console.log("onIframeLoad: iframe loaded");
    }
  }
};
</script>

<style>
.iframe-wrapper {
  border: 1px solid gray;
  height: 2000px;
}

.vue-friendly-iframe {
  height: 100%;
  width: 100%;
}
iframe {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Page/Layout/CIframe.vue